import Grid from "@mui/material/Grid2";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import { IOrder } from "@/interfaces/order.interfaces";
import { OrderDataTabMessages } from "@/messages/order-form-page/order-data-tab.messages";

import Customer from "./components/Customer";
import Delivery from "./components/Delivery";
import OrderInfo from "./components/OrderInfo";

type Props = {
  messages: OrderDataTabMessages;
  order: IOrder | null;
};

export default function OrderDataTab({ messages, order }: Props) {
  return (
    <MDBox mt={2}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <MDBox height="100%">
            <OrderInfo messages={messages} order={order} />
          </MDBox>
        </Grid>

        <Grid size={{ xs: 12, lg: 6 }}>
          <MDBox height="100%">
            <Customer messages={messages} order={order} />
          </MDBox>
        </Grid>

        <Grid size={{ xs: 12, lg: 12 }}>
          <Delivery messages={messages} />
        </Grid>
      </Grid>
    </MDBox>
  );
}
